import { render, staticRenderFns } from "./ActionShortcuts.vue?vue&type=template&id=5d50f052"
import script from "./ActionShortcuts.vue?vue&type=script&lang=ts"
export * from "./ActionShortcuts.vue?vue&type=script&lang=ts"
import style0 from "./ActionShortcuts.vue?vue&type=style&index=0&id=5d50f052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports